import { connect } from 'react-redux'
// import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'
import { PAGES } from '../../constants'

import { setNavigation } from '_actions'

import {
  fetch,
  fetchList,
  patch,
  unlink,
  // create,
  fetchAutocompleteSuggestions,
  setAutocompleteSelections,
  clearAutocompleteSuggestions
} from '_actions/serials'

import Serials from './page'

const mapStateToProps = state => ({
  serialsPage: R.pathOr({}, ['pages', PAGES.SERIALS], state)
})

const mapDispatchToProps = dispatch => ({
  // serial actions
  onRefreshSerial: R.compose(dispatch, fetch), // ({serialId})
  onModifySerial: R.compose(dispatch, patch), // ({serialId, payload})
  onUnlinkSerial: R.compose(dispatch, unlink), // ({ serialId })

  setNavigation: R.compose(dispatch, setNavigation),

  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, {pageName: PAGES.SERIALS})), // navigation
  onRefreshList: R.compose(dispatch, fetchList), // navigation, aka R.pathOr({}, ['pages', PAGES.INSTITUTIONS, 'navigation'], this.props.state)

  onCreateSerial: R.ifElse(
    serial => (serial && serial._id),
    R.compose(dispatch, setNavigation, serial => ({pageName: PAGES.SERIALS, ids: [serial._id]})),
    () => dispatch({type: 'noaction'})
  ),
  // main serial autocomplete
  onTermChange: R.compose(dispatch, fetchAutocompleteSuggestions), // term
  onSelectionChange: R.compose(dispatch, setAutocompleteSelections), // selections
  onClearSuggestions: R.compose(dispatch, clearAutocompleteSuggestions)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Serials)



// WEBPACK FOOTER //
// ./webAdmin/components/serials/index.js